<template>
  <div class="nav-wrapper">
    <div class="mobile-header">
      <button class="mobile-menu-toggle" @click="toggleMobileMenu">
<span></span>
<span></span>
<span></span>
      </button>
      <img 
        src="img/armada-logo.png" 
        alt="Armada Logo" 
        class="mobile-logo"
        loading="lazy"
        width="120"
        height="24"
      />
    </div>
    <nav class="navbar" :class="{ 'mobile-open': isMobileMenuOpen }">
      <div class="navbar-content">
        <div class="logo desktop-only">
          <img 
            src="img/armada-logo.png" 
            alt="Armada Logo" 
            class="logo-image"
            loading="lazy"
            width="200"
            height="40"
          >
        </div>
        <div class="nav-links">
          <a href="#" class="nav-link" @click.prevent="$emit('show-chat-info'); closeMobileMenu()">Where These Came From</a>
          <a href="#" class="nav-link" @click.prevent="$emit('show-who-we-are'); closeMobileMenu()">Who We Are</a>
          <a href="https://www.youtube.com/watch?v=wW2jDHvevtg&list=PLboNZ8lgLkUi3VkSK68BHYaHogET8ayJU&index=1" class="nav-link" @click="closeMobileMenu">Our Analysis Of These Messages</a>
        </div>
        <div class="info-card">
          <p>🚀 We monitor this kind of data on behalf of you and your organization.</p>
          <a href="https://risk3sixty.com/armada/attack-surface-management?utm_source=armada-blackbasta" target="_blank" class="info-link">
            Learn more about Attack Surface Management from Armada
          </a>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'Navbar',
  emits: ['show-chat-info', 'show-who-we-are'],
  data() {
    return {
      isMobileMenuOpen: false
    }
  },
  methods: {
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false;
    }
  }
}
</script>

<style scoped>
.nav-wrapper {
  position: relative;
}

.mobile-header {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  padding: 0 1rem;
  
  align-items: center;
  justify-content: space-between;
  z-index: 102;
}

.mobile-menu-toggle {
  display: none;
  background: none;
  border: none;
  padding: 0.5rem;
  cursor: pointer;
}

.mobile-menu-toggle span {
  display: block;
  width: 25px;
  height: 2px;
  background-color: var(--text-primary);
  margin: 5px 0;

}

.mobile-logo {
  height: 24px;
  width: auto;
}

.navbar {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: 300px;
  border-right: 1px solid var(--border);
  z-index: 100;
  transition: transform 0.3s ease;
}

.navbar-content {
  height: 100%;
  padding: 2rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.logo {
  margin-bottom: 1rem;
}

.logo-image {
  height: 40px;
  width: auto;
}

.nav-links {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.nav-link {
  color: var(--text-primary);
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
  padding: 0.5rem 0;
}

.nav-link:hover {
  color: var(--primary);
}

.info-card {
  background-color: var(--primary);
  color: white;
  padding: 1rem;
  border-radius: 8px;
  margin-top: auto;
}

.info-link {
  color: white;
  text-decoration: underline;
  font-weight: 500;
  display: block;
  margin-top: 0.5rem;
}

.info-link:hover {
  opacity: 0.9;
}

@media (max-width: 768px) {
  .mobile-header {
    display: flex;
  }

  .mobile-menu-toggle {
    display: block;
  }

  .navbar {
    transform: translateX(-100%);
    width: 100%;
    max-width: 300px;
    top: 60px;
    height: calc(100% - 60px);
  }

  .navbar.mobile-open {
    transform: translateX(0);
    background-color: var(--background);
  }

  .desktop-only {
    display: none;
  }

  .navbar-content {
    padding-top: 1rem;
  }


}
</style> 